// extracted by mini-css-extract-plugin
export var icons = "styles-module--icons--wwxTt";
export var texts = "styles-module--texts--U0ORF";